import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto as fromMergedTableDto, toDto as toMergedTableDto } from '../../../models/adapters/MergedTableAdapter';
import { fromDto as reservationFromDto, toDto as toReservationDto } from '../../../models/adapters/ReservationAdapter';
import { toDto as toReservationSeatingDto } from '../../../models/adapters/ReservationSeatingAdapter';
import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import { successMap } from '../../../models/interfaces/reservation/ReservationAcceptState';
import ReservationRejectReason, { failureMap } from '../../../models/interfaces/reservation/ReservationRejectReason';
import {
  acceptReservation,
  AcceptReservationPayload,
  reservationAccepted,
  reservationAcceptFailed,
  ReservationAcceptFailedPayload,
} from '../../actions/reservation/acceptReservation';
import { reservationsUpdated } from '../../actions/reservation/reservationsUpdated';
import { store } from '../../store';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* acceptReservationSaga({ payload }: Action<AcceptReservationPayload>) {
  const { pendingReservation, seating, mergedTable } = payload;
  const reservationDto = toReservationDto(pendingReservation);
  const reservationSeatingDto = seating != null ? toReservationSeatingDto(seating) : null;
  const mergedTableDto = mergedTable != null ? toMergedTableDto(mergedTable) : null;
  const token = yield getAuthenticationToken();
  const socketPayload = { reservationDto, reservationSeatingDto, mergedTableDto };
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.acceptReservation, token, socketPayload);
  const { error, reservationConfirmation } = response;
  const timestamp = moment();
  const unknownRejectPayload: ReservationAcceptFailedPayload = {
    timestamp,
    reservationUuid: pendingReservation.uuid,
    rejectReason: ReservationRejectReason.Unknown,
  };
  if (reservationDto.realTime == true) {
    const { placeUuid } = reservationDto;
    store.dispatch(reservationsUpdated({ placeUuid, timestamp: moment() }));
  }
  if (error || !reservationConfirmation) {
    yield put(reservationAcceptFailed(unknownRejectPayload));
  } else if (successMap.has(reservationConfirmation)) {
    const { acceptedReservation: acceptedReservationDto, createdMergedTable: createdMergedTableDto } = response;
    const acceptedReservation = reservationFromDto(acceptedReservationDto) as SeatedReservation;
    const createdMergedTable = createdMergedTableDto ? fromMergedTableDto(createdMergedTableDto) : null;

    const createdPayload = {
      timestamp,
      acceptState: successMap.get(reservationConfirmation),
      reservation: acceptedReservation,
      reservationUuid: acceptedReservation.uuid,
      createdMergedTable,
    };

    yield put(reservationAccepted(createdPayload));
  } else if (failureMap.has(reservationConfirmation)) {
    const failedPayload = {
      timestamp,
      rejectReason: failureMap.get(reservationConfirmation),
      reservationUuid: pendingReservation.uuid,
    };

    yield put(reservationAcceptFailed(failedPayload));
  } else {
    yield put(reservationAcceptFailed(unknownRejectPayload));
  }
}

export default function* watchAcceptReservationSaga() {
  yield takeEvery(acceptReservation, acceptReservationSaga);
}
